export default class StocksGestionRapportActiviteService {
	static $inject = ['$http'];

	constructor($http) {
		this.$http = $http;
	}

	async getSocietes() {
		let url = `${__configuration.apiUrl}/massia/societes-commerciales`;
		let res = await this.$http.get(url);
		return res.data;
	}

	async getSites(societeId) {
		const res = await this.$http.get(`${__configuration.apiUrl}/massia/regroupement-sites/societe/${societeId}`);
		return res.data;
	}

	async getMotifs() {
		let url = `${__configuration.apiUrl}/massia/motifs-ajustement-stock/headers`;
		let res = await this.$http.get(url);
		return res.data;
	}

	async getRapportsByCodeDomaine(codeDomaine, idGroupeSite) {
		let url = `${__configuration.apiUrl}/massia/gestion/rapports-activites/code-domaine/${codeDomaine}/groupe-site/${idGroupeSite}`;
		let res = await this.$http.get(url);
		return res.data;
	}

	async getGestionRapport(idSite, idRapport, dateDebut, dateFin) {
		let filtres = {
			idGroupeSite: idSite,
			idRapport: idRapport,
			dateDebut: dateDebut,
			dateFin: dateFin
		};
		let url = `${__configuration.apiUrl}/massia/gestion/gestion-rapport-activite`;
		let res = await this.$http.get(url, {
			params: {
				filtres: JSON.stringify(filtres || {})
			}
		});
		return res.data;
	}

	async getGestionRapportSynthese(idSite, idNiveau, dateDebut, dateFin) {
		let filtres = {
			idGroupeSite: idSite,
			idNiveau: idNiveau,
			dateDebut: dateDebut,
			dateFin: dateFin
		};
		let url = `${__configuration.apiUrl}/massia/gestion/gestion-rapport-activite-synthese`;
		let res = await this.$http.get(url, {
			params: {
				filtres: JSON.stringify(filtres || {})
			}
		});

		return res.data;
	}

	async updateGestionRapport(data) {
		let url = `${__configuration.apiUrl}/massia/gestion/gestion-rapport-activite`;
		const result = await this.$http.post(url, data);
		return result.data;
	}

	async export(idSite, rapportIds, dateDebut, dateFin) {
		let filtres = {
			idGroupeSite: idSite,
			idsRapport: rapportIds,
			dateDebut: dateDebut,
			dateFin: dateFin
		};
		let url = `${__configuration.apiUrl}/massia/gestion/gestion-rapport-activite/export`;
		let res = await this.$http.get(url, {
			params: {
				filtres: JSON.stringify(filtres || {})
			},
			responseType: 'blob',
			observe: 'response'
		});

		return res;
	}

	async exportSynthese(idSite, idNiveau, dateDebut, dateFin) {
		let filtres = {
			idGroupeSite: idSite,
			idNiveau: idNiveau,
			dateDebut: dateDebut,
			dateFin: dateFin
		};
		let url = `${__configuration.apiUrl}/massia/gestion/gestion-rapport-activite-synthese/export`;
		let res = await this.$http.get(url, {
			params: {
				filtres: JSON.stringify(filtres || {})
			},
			responseType: 'arraybuffer'
		});

		return res;
	}

	async getProduitsByGroupeSite(idGrpSite, idProduitSource, idProducteurSource) {
		let url = `${__configuration.apiUrl}/massia/produits/grpsite/${idGrpSite}/produit-source/${idProduitSource}/producteur-source/${idProducteurSource}`;
		let res = await this.$http.get(url);
		return res.data;
	}

	async refreshMouvements(idGroupeSite) {
		let url = `${__configuration.apiUrl}/massia/gestion/gestion-rapport-activite/refresh-mouvements/${idGroupeSite}`;
		let res = await this.$http.get(url);
		return res.data;
	}

	async refreshMouvementProgress(idGroupeSite) {
		let url = `${__configuration.apiUrl}/massia/gestion/gestion-rapport-activite/refresh-mouvements-progress/${idGroupeSite}`;
		let res = await this.$http.get(url);
		return res.data;
	}
}
